import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router'
import { Toaster } from 'sonner'
import React from 'react'

import { useSessionStore } from './store/auth/auth.store'
import { Login } from './pages/Login'

import { Layout } from './components/Layout'
import { Clients } from './pages/Clients'
import { Dashboard } from './pages/Dashboard'
import { Inventory } from './pages/Inventory'
import { Loyalty } from './pages/Loyalty'
import { MultiBranch } from './pages/MultiBranch'
import { PointOfSale } from './pages/PointOfSale'
import { Purchases } from './pages/Purchases'
import { Regulatory } from './pages/Regulatory'
import { Reports } from './pages/Reports'
import { Sales } from './pages/Sales'
import { Users } from './pages/Users'
import { Sucursals } from './pages/Sucursals'
import { Categorias } from './pages/Categorias'
import { LogsAccesos } from './pages/LogsAccesos'
import { LogsAcciones } from './pages/LogsAcciones'
import { Departments } from './pages/Departments'
import { ProductTypes } from './pages/ProductTypes'
import { Taxes } from './pages/Taxes'
import { Units } from './pages/Unit'
import { Notifications } from './pages/Notifications'
import { PlatformSettings } from './pages/PlatformSettings'

// Wrapper para proteger rutas
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const token = useSessionStore((s) => s.token)
  const location = useLocation()

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

export default function App() {
  const token = useSessionStore((s) => s.token)

  return (
    <BrowserRouter>
      <Routes>
        {/* Ruta pública / Login */}
        <Route
          path="/login"
          element={
            token ? (
              <Navigate to="/" replace />
            ) : (
              <Login onAuthenticated={() => {
                // Token is set inside Login via authStore, redirect is handled by react-router on re-render
              }} />
            )
          }
        />

        {/* Rutas Protegidas */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/pos" element={<PointOfSale />} />
                  <Route path="/ventas" element={<Sales />} />
                  <Route path="/inventario" element={<Inventory />} />
                  <Route path="/compras" element={<Purchases />} />
                  <Route path="/reportes" element={<Reports />} />
                  <Route path="/clientes" element={<Clients />} />
                  <Route path="/lealtad" element={<Loyalty />} />
                  <Route path="/usuarios" element={<Users />} />
                  <Route path="/regulatorio" element={<Regulatory />} />
                  <Route path="/dashboard-sucursales" element={<MultiBranch />} />
                  <Route path="/sucursales" element={<Sucursals />} />
                  <Route path="/categorias" element={<Categorias />} />
                  <Route path="/logs-accesos" element={<LogsAccesos />} />
                  <Route path="/logs-acciones" element={<LogsAcciones />} />
                  <Route path="/departamentos" element={<Departments />} />
                  <Route path="/tipos-producto" element={<ProductTypes />} />
                  <Route path="/impuestos" element={<Taxes />} />
                  <Route path="/unidades-medida" element={<Units />} />
                  <Route path="/configuracion/plataforma" element={<PlatformSettings />} />
                  <Route path="/notificaciones" element={<Notifications />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  )
}
